<template>
	<div class="settings">
		<v-layout row wrap>
			<v-flex md10>
				<filter-list
					class="mb-3"
					:value="filterValue"
					:loading="loading"
					@selected-filter="selectedFilter" />
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create
					text="Estado de hab."
					:href="createHref">
				</button-create>
			</v-flex>
		</v-layout>
		<table-run
			:columns="columns"
			:rows="rows"
			:include-delete="false"
			:include-export-to-excel="false"
			:selectable="false"
			switch-value="flagActive"
			include-options
			include-switch
			include-settings
			include-delete-single
			@on-search-event="searchByColumn"
			@on-change-state="changeState"
			@on-delete-event="deleteRow"
			@go-to-edit-page="goToEdit"
			@on-column-event="columnSortableEvent"
			class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>
					<room-status
						v-if="props.row.urlImage &&
							props.row.urlImage !== preimage"
						:background-color="props.row.colorState"
						:status-icon-img="props.row.urlImage"
						:size="'small'"
						:name="props.row.codeState"
						:room="props.row">
					</room-status>
					<room-status
						v-else
						size="small"
						:background-color="props.row.colorState"
						:status-icon-img="props.row.iconUrl"
						:name="props.row.codeState"
						:room="props.row">
					</room-status>
				</td>
				<td>{{props.row.name}}</td>
				<td>{{props.row.createdAt}}</td>
			</template>    
		</table-run>
		<v-layout row wrap justify-end mt-3>
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="params.page"
				@input="loadData">
			</v-pagination>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';
import RoomStatus from '@/components/shared/RoomStatus';

const helperData = helper.data();

function created() {
	this.loadData();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.params.sortField = newColumn[0].code;
	this.params.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

async function loadData(page = 1) {
	this.params.page = this.params.page > 1 ? this.params.page : page;
	const { data: states } = await this.$http.get(`${process.env.PMS_URL}/states-list`,
		{ params: this.params });
	this.totalPages = states.meta.pagination.total_pages;
	this.rows = states.data;
}

async function changeState({ id }) {
	const state = this.rows.find(row => row.id === id);
	const modelState = {
		flagActive: state.flagActive,
	};
	await this.$http.put(`${process.env.PMS_URL}/states/${id}`, modelState);
	this.showNotification('El estado del registro se actualizó correctamente.', 'success');
	this.loadData();
}

async function deleteRow({ id }) {
	await this.$http.delete(`${process.env.PMS_URL}/states/${id}`);
	this.showNotification('El estado se eliminó correctamente.', 'success');
	this.loadData();
}

function goToEdit({ id }) {
	const editHref = { name: 'states-config', params: { stateId: id } };
	this.$router.push(editHref);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	if (search) {
		this.params.search = search;
	} else {
		delete this.params.search;
	}
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id > 1) {
		this.params.flagActive = filter.id === 2 ? 1 : 0;
	} else {
		delete this.params.flagActive;
	}
	this.loadData();
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Tipo', code: 'code_state', isSortable: { down: false, up: false } },
			{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } },
			{ id: 3, name: 'Fecha de creación', code: 'created_at', isSortable: { down: false, up: false } },
		],
		createHref: { name: 'states-new' },
		filterValue: 1,
		loading: false,
		page: 1,
		params: {
			page: 1,
			perPage: 10,
		},
		preimage: helperData.preimageUrl,
		rows: [],
		totalPages: 1,
	};
}

export default {
	name: 'states-list',
	components: {
		ButtonCreate,
		FilterList,
		RoomStatus,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	created,
	data,
	methods: {
		changeState,
		columnSortableEvent,
		deleteRow,
		goToEdit,
		loadData,
		searchByColumn,
		selectedFilter,
	},
	mixins: mixin,
};
</script>



// WEBPACK FOOTER //
// List.vue?0e3e423d